export function generateOpacity(index, level, maxLevel) {
    var minOpacity = 0.2;
    var maxOpacity = 1;
    var opacityIncrement = (maxOpacity - minOpacity) / (level > maxLevel ? maxLevel : level);
    return opacityIncrement * (index + 1) + minOpacity;
}
